
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MailboxInterface } from '@/services/Mailbox/interfaces';

@Component
export default class DeleteMailboxDialog extends Vue {
  @Prop() public mailbox!: MailboxInterface;
  @Prop() public readonly onDelete!: CallableFunction;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove mailbox?`;
  }

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async deleteMailbox(): Promise<void> {
    this.$emit('delete', this.mailbox);
    this.destroyComponent();
  }
}
